export enum ForeignIpEvaluationReasonType {
  GeolocationCountryIsOnSanctionedCountriesList = 'GeolocationCountryIsOnSanctionedCountriesList',
  SigninIpCountryIsOnSanctionedCountriesList = 'SigninIpCountryIsOnSanctionedCountriesList',
  CurrentSigninIpIsOnSanctionList = 'CurrentSigninIpIsOnSanctionList',
  DeviceTimeZoneIsOnSanctionedTimeZonesListGeolocationRequired = 'DeviceTimeZoneIsOnSanctionedTimeZonesListGeolocationRequired',
  SignInIpIsForeignAndUserForeignStreakExceededMonths = 'SignInIpIsForeignAndUserForeignStreakExceededMonths',
  GeolocationLookupFailed = 'GeolocationLookupFailed',
  SkipGeolocationCheck = 'SkipGeolocationCheck',
  GeolocationCountryIsForeignCountry = 'GeolocationCountryIsForeignCountry',
  GeolocationCountryIsDomesticCountry = 'GeolocationCountryIsDomesticCountry',
  DeviceTimeZoneIsDomesticTimeZones = 'DeviceTimeZoneIsDomesticTimeZones',
}

export const SANCTIONED_SIGNIN_IP_REASONS: string[] = [
  ForeignIpEvaluationReasonType.SigninIpCountryIsOnSanctionedCountriesList,
  ForeignIpEvaluationReasonType.CurrentSigninIpIsOnSanctionList,
];

export const SANCTIONED_LOCATION_REASONS: string[] = [
  ...SANCTIONED_SIGNIN_IP_REASONS,
  ForeignIpEvaluationReasonType.GeolocationCountryIsOnSanctionedCountriesList,
];



// WEBPACK FOOTER //
// ./src/model/types/foreign-ip-evaluation-reason-type.ts